import { IImageFragment } from 'generated/sanity-graphql';

export const mockedQuestData = Array(3).fill({
  title: {
    locale: 'Free Chicken Sandwich',
  },
  image: {
    locale: {
      asset: {
        metadata: {
          __typename: 'SanityImageMetadata',
        },
        _id: 'image-0fe568ca4a01196a9a1ccc8068746b52c49ab4a0-240x97-svg',
        __typename: 'SanityImageAsset',
      },
      __typename: 'Image',
    } as IImageFragment,
    __typename: 'LocaleImage',
  },
  description: {
    locale: 'Order 3 times in a week to unlock this deal.',
  },
  expiration: {
    locale: 'Expires in 5 days',
  },
});

export type Quest = typeof mockedQuestData[0];

export const useQuests = () => {
  return { data: mockedQuestData, loading: false };
};
